/** Per-device alert sound preference (off by default). Mute lives in lib/prefs (`muteAlerts`). */
import { create } from 'zustand';
import { safeGet, safeSet } from '../../lib/prefs';

const KEY = 'apos.alerts.chime.v1';

interface AlertPrefs {
  chime: boolean;
  setChime(v: boolean): void;
}

export const useAlertPrefs = create<AlertPrefs>((set) => ({
  chime: safeGet(KEY) === '1',
  setChime(v) {
    safeSet(KEY, v ? '1' : '0');
    set({ chime: v });
  },
}));
